import InboxPage from "@/components/admin/InboxPage";

export default function SaranJamaah() {
  return <InboxPage title="Saran Jamaah" subtitle="Inbox saran & aspirasi dari portal jamaah" endpoint="suggestions" prefix="admin-saran" emptyText="Belum ada saran masuk." />;
}
